import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

function AppMenu({ faIcon, title, link, gradientClass, isExternal = false }) {
    const navigate = useNavigate();
    
    const handleClick = (e) => {
        if (isExternal) {
            e.preventDefault();
            window.open(link, "_blank", "noopener,noreferrer");
        } else {
            e.preventDefault();
            navigate(link);
        }
    };

    return (
        <div className="app-icon-card">
            <Link 
                to={isExternal ? '#' : link} 
                onClick={handleClick}
                className={`app-icon-inner ${gradientClass}`}
            >
                <div className="app-icon-wrapper">
                    <i className={faIcon}></i>
                </div>
                <p className="app-icon-title">{title}</p>
            </Link>
        </div>
    );
}

function Home() {
    useEffect(() => {
        document.title = 'app.saadixl.com';
    }, []);

    return (
        <div className="App home">
            <div className="App-header">
                <div className="home-header">
                    <h1 className="home-header-title">app.saadixl.com</h1>
                    <p className="home-header-subtitle">App collection of saadixl</p>
                </div>
            </div>
            <div className="App-body home-body">
                <div className="app-icons-grid">
                    <AppMenu 
                        gradientClass="ninety-nine-names-1-gold" 
                        link="https://amol.saadixl.com/99names" 
                        faIcon="fa-solid fa-list" 
                        title="99 Names"
                        isExternal={true}
                    />
                    <AppMenu 
                        gradientClass="budget-icon-1" 
                        link="https://budgetics.saadixl.com" 
                        faIcon="fa-solid fa-money-check-dollar" 
                        title="Budgetics"
                        isExternal={true}
                    />
                    <AppMenu 
                        gradientClass="quran-icon-1" 
                        link="https://amol.saadixl.com/quran" 
                        faIcon="fa-solid fa-book-quran" 
                        title="Quran"
                        isExternal={true}
                    />
                    <AppMenu 
                        gradientClass="prayer-icon-1" 
                        link="https://amol.saadixl.com/prayertimes" 
                        faIcon="fa-solid fa-mosque" 
                        title="Prayer Times"
                        isExternal={true}
                    />
                    <AppMenu 
                        gradientClass="trading-icon-1" 
                        link="https://tradeviser.saadixl.com" 
                        faIcon="fa-solid fa-chart-simple" 
                        title="Tradeviser"
                        isExternal={true}
                    />
                    <AppMenu 
                        gradientClass="inventory-icon-gradient-1" 
                        link="https://ventory.saadixl.com" 
                        faIcon="fa-solid fa-warehouse" 
                        title="Ventory"
                        isExternal={true}
                    />
                    <AppMenu 
                        gradientClass="home-icon-1" 
                        link="https://saadixl.com" 
                        faIcon="fa-solid fa-house-user" 
                        title="saadixl.com"
                        isExternal={true}
                    />
                </div>
            </div>
        </div>
    );
}

export default Home;